/* Bonheur — collection/grid quick add-to-cart.
   Single-variant products add directly via AJAX then redirect to the cart page;
   multi-variant (size) cards are rendered as links to the PDP so we never add the wrong variant. */
(function () {
  'use strict';

  var I18N = (window.CARD_ATC_I18N || {});
  var TXT_ERROR = I18N.error || 'Tekrar deneyin';
  var TXT_SOLDOUT = I18N.soldout || 'Tükendi';
  var RESET_MS = 1800;
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('data-loading') === '1') return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    // Gift-eligible bag → open the gift-picker popup (choose the free strap) instead of a direct add.
    if (btn.getAttribute('data-card-gift') === '1' && typeof window.__giftPickerOpen === 'function') {
      window.__giftPickerOpen(Number(id), 1);
      return;
    }

    var label = btn.querySelector('.card-atc__label') || btn;
    var original = label.textContent;

    btn.setAttribute('data-loading', '1');
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            var e = new Error(d.description || d.message || ('cart/add ' + r.status));
            e.status = r.status;
            throw e;
          });
        }
        return r.json();
      })
      .then(function () {
        // Added successfully — take the customer straight to the cart.
        window.location.href = CART_URL;
      })
      .catch(function (err) {
        // Surface, never swallow silently.
        console.error('[card-atc] add failed', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        // 422 = out of stock / cart already holds all stock: retrying cannot succeed, so say so
        // and leave the button inert (data-loading stays '1') instead of looping "Tekrar deneyin".
        if (err && err.status === 422) {
          btn.classList.remove('is-error');
          btn.classList.add('card-atc--soldout'); // same muted look as server-rendered sold-out cards
          label.textContent = TXT_SOLDOUT;
          return;
        }
        label.textContent = TXT_ERROR;
        setTimeout(function () {
          btn.classList.remove('is-error');
          label.textContent = original;
          btn.setAttribute('data-loading', '0');
        }, RESET_MS);
      });
  });
})();